import { APP, ENV } from "app_constants";

const TRACK_JS_TOKEN = "fd970d226c4b475d897759f950989046";
const STAGING_APP_KEY = "staging-all";

const TRACK_JS_CONFIG = {
  olo: {
    staging: STAGING_APP_KEY,
    production: "olo-prod",
  },
  pay: {
    staging: STAGING_APP_KEY,
    production: "pay-prod",
  },
  loyalty: {
    staging: STAGING_APP_KEY,
    production: "loyalty-prod",
  },
  giftCard: {
    staging: STAGING_APP_KEY,
    production: "digital-gift-cards-prod",
  },
};

const TRACK_JS_APPLICATION_KEY =
  APP === "unknown" ? STAGING_APP_KEY : TRACK_JS_CONFIG[APP][ENV];

export { TRACK_JS_APPLICATION_KEY, TRACK_JS_TOKEN };
